import useOrder from 'hooks/Order/useOrder'
import UpcomingEscapeCard from './UpcomingEscapeCard'
import useUpcomingEscapeUpsells from './useUpcomingEscapeUpsells'
import { hasUpcomingEscapeVisibleRows } from './getUpcomingEscapeRowEligibility'

interface Props {
  order: App.Order
}

/**
 * Homepage upcoming orders are fetched in useEffect, so this section is absent
 * from SSR HTML either way. We still wait until a row can paint before mounting
 * the card: hide-on-load is intentional so we never show a booking shell with
 * zero upsell rows. That also delays hero fetches until the card mounts, and
 * dismissing the last visible row unmounts the card (same gate).
 */
function UpcomingEscapeSection({ order }: Props) {
  const [fullOrder] = useOrder(order.id)
  const resolvedOrder = fullOrder ?? order
  const upsells = useUpcomingEscapeUpsells(resolvedOrder)
  const showCard = hasUpcomingEscapeVisibleRows(upsells.eligibility)

  return showCard ? <UpcomingEscapeCard order={resolvedOrder} upsells={upsells} /> : null
}

export default UpcomingEscapeSection
